import { render, staticRenderFns } from "./ImmigrationDetail.vue?vue&type=template&id=24e90e8e&scoped=true"
import script from "./ImmigrationDetail.vue?vue&type=script&lang=js"
export * from "./ImmigrationDetail.vue?vue&type=script&lang=js"
import style0 from "./ImmigrationDetail.vue?vue&type=style&index=0&id=24e90e8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e90e8e",
  null
  
)

export default component.exports